// 边详情视图（左侧面板 + 边表格）- 简体中文
export default {
  common: {
    loading: "拼命加载中",
    copySuccess: "复制成功",
    noticeTitle: "提示",
    successTitle: "成功",
    errorTitle: "错误",
    totalPrefix: "共计 ",
    totalSuffix: " 条数据",
    unitTx: "笔",
    averagePrefix: "平均",
    noData: "暂无数据",
    viewInExplorer: "浏览器查看",
    notePrefix: "备注：",
    itemsUnit: "条",
    // Added for hash note table actions
    addSurvey: "加入调证",
    normalSurvey: "普通调证",
    importantSurvey: "重点调证",
    note: "备注",
    tipTitle: "提示",
  },

  fields: {
    ownership: "地址归属",
    watchingAddress: "观察地址",
    inflow: "流入",
    outflow: "流出",
    firstInflow: "首笔转入",
    crossChainSwap: "跨链换币",
    CoinJoin: "混币交易",
    sameIPShort: "同时段同IP",
    sameDeviceShort: "同设备账号",
  },
  titles: {
    transactionDetails: "交易详情",
    sameIP: "同时段同IP明细",
    sameDevice: "同设备明细",
    crossChain: "跨链交易详情",
    hashNote: "哈希备注",
    coinJoin: "混币交易详情",
  },
  coinJoinTrace: {
    title: "混币追踪",
    subtitle: "根据交易时间快速定位混币交易并一键上图",
    tooltiptitle: "操作步骤：",
    tooltip:
      "1、确定混币追踪的起始时间（支持点击交易时间快速追踪）\n2、选择追踪的时间范围\n3、点击「追踪上图」，在画布查看匹配到的混币流出交易",
    timeLabel: "追踪时间",
    rangeLabel: "追踪范围",
    traceButton: "追踪上图",
    traceTooltip:
      "ps：系统基于时间相近匹配，作为辅助线索使用，不能作为\n唯一判定依据。建议结合其他链上信息与人工判断。",
    rangeOptions: {
      8: "8小时内",
      16: "16小时内",
      24: "24小时内",
      48: "48小时内",
    },
  },
  messages: {
    notAllowSurvey: "此条内容不可调证",
    addressNotFound: "没有查出该地址",
    downloadFailed: "下载失败，请稍后重试",
    fetchFailed: "获取数据失败，请稍后重试",
    surveyAdded: "已加入调证",
    copySuccess: "复制成功",
  },
  leftEdge: {
    sender: "发送方",
    receiver: "接收方",
    crossChainTooltip:
      "bridgers跨链可能涉及三个平台，通过三方浏览器查看时可自行切换OmniBridge、Bridgers、CrossChainX查询跨链数据",
    stargateTooltip:
      "支持Stargate跨链协议的数据追踪，可通过'跨链追踪'一键查询跨链数据并上图分析",
  },
  summary: {
    totalCountLabel: " 总笔数：",
    totalQuantityLabel: " 总数量：",
    averageQuantityLabel: "平均数量：",
  },
  sameIP: {
    topNotice:
      "当前结果为{timeRange}同IP登录，如需其他时间范围可前往【扩展配置】-【同时段同IP】进行时间范围条件配置",
    topNoticePrefix: "当前结果为",
    topNoticeSuffix:
      "同IP登录，如需其他时间范围可前往【扩展配置】-【同时段同IP】进行时间范围条件配置",
    labels: {
      ip: "IP",
      locationPrefix: "地理位置：",
      currentUser: "[当前用户]",
      loginTime: "[登录时间]",
      sameIPUser: "[同IP用户]",
    },
    timeOptions: {
      ONE_DAY: "1天",
      THREE_DAY: "3天",
      ONE_WEEK: "1周",
      ONE_MONTH: "1月",
      THREE_MONTH: "3月",
      HALF_A_YEA: "半年",
      NOT_LIMIT: "不限",
    },
  },
  sameDevice: {
    columns: {
      manufacturer: "手机厂商",
      model: "手机型号",
      osVersion: "系统版本号",
      deviceId: "Device ID（UUID）",
      imei: "IMEI",
      mac: "MAC",
    },
  },
  firstRecord: {
    columns: {
      orderNo: "订单号",
      txHash: "交易hash",
      quantity: "交易数量",
      time: "交易时间",
      actions: "操作",
    },
    actions: {
      note: "备注",
      survey: "调证",
      surveyNormal: "普通调证",
      surveyImportant: "重点调证",
    },
  },
  dealEdge: {
    filters: {
      time: "时间",
      startDate: "开始日期",
      endDate: "结束日期",
      amountRange: "金额区间",
      minAmount: "最小金额",
      maxAmount: "最大金额",
    },
    totalPrefix: "共计",
    totalSuffix: "条数据",
    buttons: {
      download: "下载",
      joinSurvey: "加入调证",
    },
    columns: {
      orderNo: "订单号",
      txHash: "交易hash",
      quantity: "交易数量",
      time: "交易时间",
      fromUserId: "发送方用户id",
      toUserId: "接收方用户id",
      note: "备注",
    },
    tooltips: {
      hashContainsMore:
        "该条交易hash包含更多代币转账记录，可通过交易数据详情查看。",
    },
  },
  noteHistory: {
    dialogTitle: "备注历史",
    totalPrefix: "共计：",
    columns: {
      noteContent: "备注内容",
      modifier: "变更人",
      modifiedTime: "变更时间",
    },
  },
  hashNoteDialog: {
    title: "备注",
    placeholder: "请输入备注内容",
    history: "备注历史",
    cancel: "取 消",
    confirm: "确 定",
    addSuccess: "添加hash备注成功",
    updateSuccess: "修改hash备注成功",
    deleteSuccess: "删除hash备注成功",
  },
};
